//#region src/Splitter/utils/assert.ts
function assert(expectedCondition, message = "Assertion failed!") {
	if (!expectedCondition) {
		console.error(message);
		throw new Error(message);
	}
}

//#endregion
export { assert };
//# sourceMappingURL=assert.js.map